import clsx from 'clsx';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Spinner = ({ size = 'md', className }: SpinnerProps) => {
  return (
    <div
      className={clsx(
        'inline-block animate-spin rounded-full border-2 border-gold border-t-transparent',
        {
          'h-4 w-4': size === 'sm',
          'h-8 w-8': size === 'md',
          'h-16 w-16': size === 'lg',
        },
        className
      )}
    />
  );
};
